import { persianNumber, persianNumberToEnglishNumber } from "./persian-number";

export function convertPersianDateWithEnglishDigitToPersianDigitDate(theDate){
    let stringArray = theDate.split("/");
    let year = stringArray[0]
    let month = stringArray[1]
    let day = stringArray[2]

    let persianYear = persianNumber(year)
    let persianMonth = persianNumber(month)
    let persianDay = persianNumber(day);

    return `${persianYear}/${persianMonth}/${persianDay}`;

}


export function convertPersianDateToPersianDateEnglishDigit(persianDate){
    let stringArray = persianDate.split("/");
    let year = stringArray[0];
    let month = stringArray[1];
    let day = stringArray[2];

    let persianYear = persianNumberToEnglishNumber(year);
    let persianMonth = persianNumberToEnglishNumber(month);
    let persianDay = persianNumberToEnglishNumber(day);

    persianMonth = addZeroToLeftSideOfDayOrMonth(persianMonth)
    persianDay = addZeroToLeftSideOfDayOrMonth(persianDay);

    return `${persianYear}/${persianMonth}/${persianDay}`;
}  

export function addZeroToLeftSideOfDayOrMonth(initialValue){
    if(initialValue.length === 1){
        return '0' + String(initialValue);
    }
    else {
        return initialValue;
    }
} 

export function getDaysAgoFromNow(days){
    let todayDate = new Date();
    if(days > 0){
        todayDate = todayDate - 1000 * 60 * 60 * 24 * days;   // current date's milliseconds - 1,000 ms * 60 s * 60 mins * 24 hrs * (# of days beyond one to go back)
        todayDate = new Date(todayDate);
    }

    return todayDate;
}

export function convertPersianDateToNumber(persianDate){
    let stringArray = persianDate.split("/");
    let year = stringArray[0];
    let month = stringArray[1];
    let day = stringArray[2];
    stringArray = year+month+day;    
    return Number(stringArray);
}

export function calculatePersianNowDateNumber(){
    let nowIs = new Date().toLocaleDateString('fa-IR');
    nowIs = convertPersianDateToPersianDateEnglishDigit(nowIs);
    nowIs = convertPersianDateToNumber(nowIs);
    return nowIs;
}